import React from 'react';
import { withTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { VenueService } from '../../services';
import { Converter, EntityError } from '../../utils';
import { DefaultButton, LoadingButton } from '../buttons';
import { TextField, Checkbox, Map, Uploader, TagInput, DropDown, CountrySelect } from '../fields';
import { ModalLayout } from '../layouts';
import DeliveryZonesMapModal from './DeliveryZonesMapModal';

import '../../styles/modals/modal.css';
import { Toast } from '../alerts';
import '../../styles/modals/savevenue.css';
import 'leaflet/dist/leaflet.css';
import Constants from '../../Constants';

class SaveVenueModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      show: false,
      showDeliveryZonesMap: false,
      name: '',
      email: '',
      address: '',
      phone: '',
      postCode: '',
      lat: null,
      lng: null,
      seatCodes: [],
      photo: null,
      serviceType: 1,
      isStadium: false,
      seatFirstNumber: '',
      seatLastNumber: '',
      isQrcodeRequiredTableService: true,
      serviceFeeRate: 0,
      currency: 'GBP',
      country: 'GB',
      vatNumber: '',
      vatRate: 0,
      deliveryOptions: [],
      isDelivery: false,
      isCollection: false,
      acceptsCashCollection: false,
      tipsEnabled: true,
      inVenueOrdering: true,
      collectionPrepTime: 15,
      collectionSlotInterval: 15,
      collectionOrderLeadTime: 0,
      deliveryZones: [{ max_distance_miles: '', min_order: '', delivery_fee: '' }],
      paymentProvider: 1,
      invalidPost: {
        name: false,
        email: false,
        address: false,
        phone: false,
        postCode: false,
        lng: false,
        lat: false,
        photo: false,
        seat_first_number: false,
        seat_last_number: false,
        is_qrcode_required_ts: false,
        currency: false,
        country: false,
        vat_number: false,
        vat_rate: false,
        delivery_options: false,
        is_delivery: false,
        payment_provider: false,
      },
    };

    this.show = this.show.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.setFields = this.setFields.bind(this);
    this.onSaveBtnCLick = this.onSaveBtnCLick.bind(this);
    this.onServiceTypeChange = this.onServiceTypeChange.bind(this);
    this.onIsStadiumChange = this.onIsStadiumChange.bind(this);
    this.onDeliveryOptionChange = this.onDeliveryOptionChange.bind(this);
    this.onIsQrcodeRequiredTableServiceChange = this.onIsQrcodeRequiredTableServiceChange.bind(this);
    this.onProductPhotoChange = this.onProductPhotoChange.bind(this);
    this.onMapClick = this.onMapClick.bind(this);

    this.venueService = new VenueService();
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  resetFields() {
    this.setState({
      loading: false,
      show: false,
      showDeliveryZonesMap: false,
      name: '',
      email: '',
      address: '',
      phone: '',
      postCode: '',
      lat: null,
      lng: null,
      seatCodes: [],
      photo: null,
      serviceType: 1,
      isStadium: false,
      seatFirstNumber: '',
      seatLastNumber: '',
      isQrcodeRequiredTableService: true,
      serviceFeeRate: 0,
      currency: 'GBP',
      country: 'GB',
      vatNumber: '',
      vatRate: 0,
      deliveryOptions: [],
      isDelivery: false,
      minDeliveryOrder: 0,
      maxDeliveryDistanceMiles: 10,
      deliveryZones: [{ max_distance_miles: '', min_order: '', delivery_fee: '' }],
      paymentProvider: 1,
      invalidPost: {
        name: false,
        email: false,
        address: false,
        phone: false,
        postCode: false,
        lng: false,
        lat: false,
        photo: false,
        seat_first_number: false,
        seat_last_number: false,
        is_qrcode_required_ts: false,
        currency: false,
        country: false,
        vat_number: false,
        vat_rate: false,
        delivery_options: false,
        is_delivery: false,
        payment_provider: false,
      },
    });
  }

  show(set = true) {
    const { venueId } = this.props;

    this.resetFields();
    this.setState({
      show: set,
    });

    if (this.map) {
      this.map.setZoom(venueId ? 15 : 13);
    }
  }

  setFields(venue) {
    this.setState({
      name: venue.name,
      email: venue.email,
      address: venue.contacts.address,
      phone: venue.contacts.phone,
      postCode: venue.contacts.post_code,
      lng: venue.location.coordinates[0],
      lat: venue.location.coordinates[1],
      serviceType: venue.service_type,
      isStadium: venue.is_stadium,
      seatFirstNumber: venue.seat_numbers.first_number,
      seatLastNumber: venue.seat_numbers.last_number,
      seatCodes: venue.seat_codes || [],
      isQrcodeRequiredTableService: venue.is_qrcode_required ? venue.is_qrcode_required.for_tableservice : true,
      serviceFeeRate: venue.service_fee ? venue.service_fee.rate : 0,
      currency: venue.currency ? venue.currency : null,
      country: venue.country ? venue.country : null,
      vatNumber: venue.vat ? venue.vat.number : '',
      vatRate: venue.vat ? venue.vat.rate : 0,
      deliveryOptions: venue.delivery_options || [],
      isDelivery: venue.is_delivery || false,
      isCollection: venue.is_collection || false,
      acceptsCashCollection: venue.accepts_cash_collection || false,
      tipsEnabled: venue.tips_enabled !== undefined ? venue.tips_enabled : true,
      inVenueOrdering: venue.in_venue_ordering !== undefined ? venue.in_venue_ordering : true,
      collectionPrepTime: venue.collection_prep_time || 15,
      collectionSlotInterval: venue.collection_slot_interval || 15,
      collectionOrderLeadTime: venue.collection_order_lead_time || 0,
      minDeliveryOrder: venue.min_delivery_order || 0,
      maxDeliveryDistanceMiles: venue.max_delivery_distance_miles || 10,
      deliveryZones: venue.delivery_zones && venue.delivery_zones.length > 0 ? venue.delivery_zones : [{ max_distance_miles: '', min_order: '', delivery_fee: '' }],
      paymentProvider: venue.payment_provider || 1,
    });
  }

  onServiceTypeChange(checked, serviceType) {
    if (checked) {
      this.setState({ serviceType: serviceType });
    }
  }

  onIsStadiumChange(checked) {
    this.setState({ isStadium: checked });
  }

  onDeliveryOptionChange(checked, value) {
    const { deliveryOptions } = this.state;
    checked ? deliveryOptions.push(value) : deliveryOptions.splice(deliveryOptions.indexOf(value), 1);

    this.setState({ deliveryOptions });
  }

  onIsQrcodeRequiredTableServiceChange(checked) {
    this.setState({ isQrcodeRequiredTableService: checked });
  }

  onProductPhotoChange(photo) {
    this.setState({
      photo: photo,
    });
  }

  onMapClick(e) {
    const location = e.latlng && e.latlng.lat && e.latlng.lng ? e.latlng : null;

    if (location) {
      this.setState({
        lng: location.lng,
        lat: location.lat,
      });
    }
  }

  async onSaveBtnCLick() {
    const { venueId, onComplete } = this.props;
    const {
      invalidPost,
      name,
      email,
      address,
      phone,
      postCode,
      lng,
      lat,
      photo,
      serviceType,
      isStadium,
      seatFirstNumber,
      seatLastNumber,
      seatCodes,
      isQrcodeRequiredTableService,
      serviceFeeRate,
      currency,
      country,
      vatNumber,
      vatRate,
      deliveryOptions,
      isDelivery,
      isCollection,
      acceptsCashCollection,
      tipsEnabled,
      inVenueOrdering,
      collectionPrepTime,
      collectionSlotInterval,
      collectionOrderLeadTime,
      minDeliveryOrder,
      maxDeliveryDistanceMiles,
      deliveryZones,
      paymentProvider,
    } = this.state;

    this.setState({
      loading: true,
      invalidPost: EntityError.setInputErrors(invalidPost, null, true),
    });

    const result = venueId
      ? await this.venueService.put(
          venueId,
          name,
          email,
          address,
          phone,
          postCode,
          lng,
          lat,
          photo,
          serviceType,
          isStadium,
          seatFirstNumber,
          seatLastNumber,
          seatCodes,
          isQrcodeRequiredTableService,
          serviceFeeRate,
          country,
          vatNumber,
          vatRate,
          deliveryOptions,
          paymentProvider,
          isDelivery,
          isCollection,
          collectionPrepTime,
          collectionSlotInterval,
          collectionOrderLeadTime,
          minDeliveryOrder,
          maxDeliveryDistanceMiles,
          deliveryZones,
          acceptsCashCollection,
          tipsEnabled,
          inVenueOrdering,
        )
      : await this.venueService.post(
          name,
          email,
          address,
          phone,
          postCode,
          lng,
          lat,
          photo,
          serviceType,
          isStadium,
          seatFirstNumber,
          seatLastNumber,
          seatCodes,
          isQrcodeRequiredTableService,
          serviceFeeRate,
          currency,
          country,
          vatNumber,
          vatRate,
          deliveryOptions,
          paymentProvider,
          isDelivery,
          isCollection,
          collectionPrepTime,
          collectionSlotInterval,
          collectionOrderLeadTime,
          minDeliveryOrder,
          maxDeliveryDistanceMiles,
          deliveryZones,
          acceptsCashCollection,
          tipsEnabled,
          inVenueOrdering,
        );

    if (result && result.success) {
      this.show(false);

      onComplete(true);
    } else if (result && result.ecode === 422) {
      this.setState({
        invalidPost: EntityError.setInputErrors(invalidPost, result.errors),
      });
    }

    this.setState({
      loading: false,
    });
  }

  render() {
    const {
      show,
      loading,
      showDeliveryZonesMap,
      name,
      email,
      address,
      phone,
      postCode,
      lng,
      lat,
      serviceType,
      isStadium,
      deliveryOptions,
      isDelivery,
      isCollection,
      acceptsCashCollection,
      tipsEnabled,
      inVenueOrdering,
      collectionPrepTime,
      collectionSlotInterval,
      collectionOrderLeadTime,
      seatFirstNumber,
      seatLastNumber,
      seatCodes,
      isQrcodeRequiredTableService,
      serviceFeeRate,
      currency,
      country,
      vatNumber,
      vatRate,
      paymentProvider,
      invalidPost,
      deliveryZones,
    } = this.state;
    const { t, venueId } = this.props;

    return (
      show && (
        <ModalLayout title={venueId ? t('Update Venue') : t('Add Venue')} width={640}>
          <Row>
            <Col md={6}>
              <TextField
                fullWidth
                label={t('Name')}
                error={invalidPost.name}
                errorText={t('Name is required')}
                onChange={(e) => this.setState({ name: e.target.value })}
                value={name}
              ></TextField>
            </Col>
            <Col md={6}>
              <TextField
                fullWidth
                label={t('Email')}
                error={invalidPost.email}
                errorText={t('Email is an invalid')}
                type="email"
                onChange={(e) => this.setState({ email: e.target.value })}
                value={email}
              ></TextField>
            </Col>
            <Col md={6}>
              <TextField fullWidth label={t('Phone')} onChange={(e) => this.setState({ phone: e.target.value })} value={phone}></TextField>
            </Col>
            <Col md={6}>
              <TextField fullWidth label={t('Post Code')} onChange={(e) => this.setState({ postCode: e.target.value })} value={postCode}></TextField>
            </Col>
            <Col md={12}>
              <TextField
                fullWidth
                label={t('Address')}
                error={invalidPost.address}
                errorText={t('Address is required')}
                onChange={(e) => this.setState({ address: e.target.value })}
                value={address}
              ></TextField>
            </Col>
            <Col md={6}>
              <TextField
                fullWidth
                label={t('Seat First Number')}
                error={invalidPost.seat_first_number}
                errorText={t('Seat Number is required')}
                onChange={(e) => this.setState({ seatFirstNumber: e.target.value })}
                value={seatFirstNumber}
              ></TextField>
            </Col>
            <Col md={6}>
              <TextField
                fullWidth
                label={t('Seat Last Number')}
                error={invalidPost.seat_last_number}
                errorText={t('Seat Number is required')}
                onChange={(e) => this.setState({ seatLastNumber: e.target.value })}
                value={seatLastNumber}
              ></TextField>
            </Col>
            <Col md={4}>
              <p className="add-venue-subtitle">{t('Fees')}</p>
              <TextField
                label={t('Service Charge')}
                fullWidth
                value={serviceFeeRate}
                error={invalidPost.service_fee_rate}
                errorText={t('Service Charge must be numeric')}
                onChange={(e) =>
                  this.setState({
                    serviceFeeRate: Converter.onlyNumber(e.target.value),
                  })
                }
                rightBtnLabel={'%'}
              ></TextField>
            </Col>
            <Col md={4}>
              <p className="add-venue-subtitle">{t('Payment Provider')}</p>
              <DropDown
                label={Constants.PAYMENT_PROVIDERS.find((p) => p.id === paymentProvider)?.name || 'Stripe'}
                bold={false}
                dropdownStyle="add-venue-currency-dropdown"
                buttonStyle="add-venue-currency-dropdown-btn"
                actions={Constants.PAYMENT_PROVIDERS.map((provider) => {
                  return {
                    label: provider.name,
                    title: provider.name,
                    id: provider.id,
                  };
                })}
                onChange={(data, selectedValue) => {
                  this.setState({ paymentProvider: selectedValue.id });
                }}
              />
            </Col>
            <Col md={4}>
              <p className="add-venue-subtitle">{t('Currency')}</p>
              {venueId ? (
                <span className="add-venue-currency-text">{`${currency} ${Constants.CURRENCIES[currency].symbol}`}</span>
              ) : (
                <DropDown
                  label={`${currency} ${Constants.CURRENCIES[currency].symbol}`}
                  bold={false}
                  dropdownStyle="add-venue-currency-dropdown"
                  buttonStyle="add-venue-currency-dropdown-btn"
                  actions={Object.keys(Constants.CURRENCIES).map((key) => {
                    return {
                      label: `${key} ${Constants.CURRENCIES[key].symbol}`,
                      title: `${key} ${Constants.CURRENCIES[key].symbol}`,
                      id: key,
                    };
                  })}
                  onChange={(data, selectedValue) => {
                    this.setState({ currency: selectedValue.id });
                  }}
                />
              )}
            </Col>
            <Col md={12}>
              <Row>
                <Col md={4}>
                  <p className="add-venue-subtitle">{t('Tips')}</p>
                  <Checkbox
                    text={t('Allow tips')}
                    value={true}
                    checked={tipsEnabled}
                    onChange={(checked) => this.setState({ tipsEnabled: checked })}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={12}>
              <p className="add-venue-subtitle">{t('VAT')}</p>
              <Row>
                <Col md={4}>
                  <TextField
                    label={t('Rate')}
                    fullWidth
                    value={vatRate}
                    error={invalidPost.vat_rate}
                    errorText={t('Value is an invalid')}
                    onChange={(e) =>
                      this.setState({
                        vatRate: Converter.onlyNumber(e.target.value),
                      })
                    }
                    rightBtnLabel={'%'}
                  ></TextField>
                </Col>
                <Col md={8}>
                  <TextField
                    label={t('VAT Registration Number')}
                    fullWidth
                    value={vatNumber}
                    error={invalidPost.vat_number}
                    errorText={t('Value is an invalid')}
                    onChange={(e) => this.setState({ vatNumber: e.target.value })}
                  ></TextField>
                </Col>
              </Row>
            </Col>
            <Col md={12}>
              <p className="add-venue-subtitle">{t('Seat Codes')}</p>
              <TagInput
                tags={seatCodes}
                onlyLetter={true}
                upperCase={true}
                placeholder={t('Please press the enter key to add new seat code')}
                onTagsChanged={(tags) => {
                  this.setState({ seatCodes: tags });
                }}
              />
            </Col>
            <Col md={12}>
              <p className="add-venue-subtitle">{t('Options')}</p>
              <Row>
                <Col sm={6}>
                  <div className="add-venue-service-list">
                    <Checkbox text={t('Pick up & Table Service / Seat Order')} value={1} checked={serviceType === 1 ? true : false} onChange={this.onServiceTypeChange} />
                    <Checkbox text={t('Pick up')} value={2} checked={serviceType === 2 ? true : false} onChange={this.onServiceTypeChange} />
                    <Checkbox text={t('Table Service / Seat Order')} value={3} checked={serviceType === 3 ? true : false} onChange={this.onServiceTypeChange} />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="add-venue-service-list">
                    <Checkbox text={t('Stadium')} value={true} checked={isStadium} onChange={this.onIsStadiumChange} />
                    <Checkbox
                      text={t('QR Code Required For Table Service')}
                      value={true}
                      checked={isQrcodeRequiredTableService}
                      onChange={this.onIsQrcodeRequiredTableServiceChange}
                    />
                    <Checkbox text={t('Delivery')} value={true} checked={isDelivery} onChange={(checked) => this.setState({ isDelivery: checked })} />
                    <Checkbox text={t('Collection')} value={true} checked={isCollection} onChange={(checked) => this.setState({ isCollection: checked })} />
                    <Checkbox
                      text={t('Pick up & table service')}
                      value={true}
                      checked={inVenueOrdering}
                      onChange={(checked) => {
                        if (!checked && !isDelivery && !isCollection) {
                          Toast.warning(t('Turn on Delivery or Collection first, or customers will have no way to order.'));
                          return;
                        }
                        this.setState({ inVenueOrdering: checked });
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            {isCollection && (
              <Col md={12} style={{ marginTop: 12 }}>
                <p className="add-venue-subtitle">{t('Collection Settings')}</p>
                <Row>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Checkbox
                      text={t('Accept cash on collection')}
                      value={true}
                      checked={acceptsCashCollection}
                      onChange={(checked) => this.setState({ acceptsCashCollection: checked })}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <label style={{ minHeight: 38, display: 'block' }}>{t('Prep Time (mins)')}</label>
                    <input
                      className="form-control"
                      type="number"
                      min="5"
                      value={collectionPrepTime}
                      onChange={(e) => this.setState({ collectionPrepTime: e.target.value })}
                    />
                  </Col>
                  <Col md={4}>
                    <label style={{ minHeight: 38, display: 'block' }}>{t('Slot Interval (mins)')}</label>
                    <select
                      className="form-control"
                      value={collectionSlotInterval}
                      onChange={(e) => this.setState({ collectionSlotInterval: parseInt(e.target.value) })}>
                      <option value={15}>15 mins</option>
                      <option value={30}>30 mins</option>
                      <option value={45}>45 mins</option>
                      <option value={60}>60 mins</option>
                    </select>
                  </Col>
                  <Col md={4}>
                    <label style={{ minHeight: 38, display: 'block' }}>{t('Accept orders before opening (mins)')}</label>
                    <input
                      className="form-control"
                      type="number"
                      min="0"
                      value={collectionOrderLeadTime}
                      onChange={(e) => this.setState({ collectionOrderLeadTime: e.target.value })}
                    />
                  </Col>
                </Row>
              </Col>
            )}
            <Col md={12}>
              <p className="add-venue-subtitle">{t('Delivery Options')}</p>
              <Row>
                <Col sm={6}>
                  <div className="add-venue-service-list">
                    <Checkbox
                      text={t('Table Service')}
                      value={Constants.DELIVERY_OPTIONS[0]}
                      checked={deliveryOptions.indexOf(Constants.DELIVERY_OPTIONS[0]) > -1}
                      onChange={this.onDeliveryOptionChange}
                    />
                    <Checkbox
                      text={t('Seat Service')}
                      value={Constants.DELIVERY_OPTIONS[1]}
                      checked={deliveryOptions.indexOf(Constants.DELIVERY_OPTIONS[1]) > -1}
                      onChange={this.onDeliveryOptionChange}
                    />
                    <Checkbox
                      text={t('Room Service')}
                      value={Constants.DELIVERY_OPTIONS[2]}
                      checked={deliveryOptions.indexOf(Constants.DELIVERY_OPTIONS[2]) > -1}
                      onChange={this.onDeliveryOptionChange}
                    />
                    <Checkbox
                      text={t('Box Service')}
                      value={Constants.DELIVERY_OPTIONS[3]}
                      checked={deliveryOptions.indexOf(Constants.DELIVERY_OPTIONS[3]) > -1}
                      onChange={this.onDeliveryOptionChange}
                    />
                    <Checkbox
                      text={t('Zone Service')}
                      value={Constants.DELIVERY_OPTIONS[4]}
                      checked={deliveryOptions.indexOf(Constants.DELIVERY_OPTIONS[4]) > -1}
                      onChange={this.onDeliveryOptionChange}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            {isDelivery && <Col md={12} style={{ marginTop: 20 }}>
              <p className="add-venue-subtitle">{t('Delivery Zones')}</p>
              <p style={{ fontSize: 13, color: '#888', marginBottom: 8 }}>{t('Set a distance, minimum order and delivery fee for each zone. Zones are applied in order — the first matching zone is used.')}</p>
              <table className="table" style={{ marginTop: 12 }}>
                <thead>
                  <tr>
                    <th>{t('Zone')}</th>
                    <th>{t('Max Distance (miles)')}</th>
                    <th>{t('Min Order (£)')}</th>
                    <th>{t('Delivery Fee (£)')}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {deliveryZones.map((zone, index) => (
                    <tr key={index}>
                      <td style={{ verticalAlign: 'middle' }}>{index + 1}</td>
                      <td>
                        <input
                          className="form-control"
                          type={zone.polygon && zone.polygon.length > 2 ? 'text' : 'number'}
                          min="0"
                          placeholder={zone.polygon && zone.polygon.length > 2 ? 'Drawn' : 'e.g. 2'}
                          disabled={zone.polygon && zone.polygon.length > 2}
                          title={zone.polygon && zone.polygon.length > 2 ? 'This zone uses its drawn area instead of a distance' : ''}
                          value={zone.polygon && zone.polygon.length > 2 ? '' : zone.max_distance_miles}
                          onChange={(e) => {
                            const updated = [...deliveryZones];
                            updated[index] = { ...updated[index], max_distance_miles: e.target.value };
                            this.setState({ deliveryZones: updated });
                          }}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          type="number"
                          min="0"
                          placeholder="e.g. 12"
                          value={zone.min_order}
                          onChange={(e) => {
                            const updated = [...deliveryZones];
                            updated[index] = { ...updated[index], min_order: e.target.value };
                            this.setState({ deliveryZones: updated });
                          }}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          type="number"
                          min="0"
                          placeholder="e.g. 3"
                          value={zone.delivery_fee}
                          onChange={(e) => {
                            const updated = [...deliveryZones];
                            updated[index] = { ...updated[index], delivery_fee: e.target.value };
                            this.setState({ deliveryZones: updated });
                          }}
                        />
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <button
                          type="button"
                          className="delivery-zones-map-delete"
                          style={{ width: 'auto', padding: '0 10px', marginRight: 6 }}
                          title={zone.polygon && zone.polygon.length > 2 ? 'Drawn area, click to redraw' : 'Draw this zone on the map'}
                          onClick={() => this.setState({ showDeliveryZonesMap: true })}
                        >
                          {zone.polygon && zone.polygon.length > 2 ? 'Drawn' : 'Draw'}
                        </button>
                        {deliveryZones.length > 1 && (
                          <button
                            type="button"
                            className="delivery-zones-map-delete"
                            onClick={() => {
                              const updated = deliveryZones.filter((_, i) => i !== index);
                              this.setState({ deliveryZones: updated });
                            }}
                          >×</button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                style={{ marginBottom: 12 }}
                onClick={() => this.setState({ deliveryZones: [...deliveryZones, { max_distance_miles: '', min_order: '', delivery_fee: '', polygon: [], enabled: true }] })}
              >+ Add Zone</button>

              <div style={{ marginBottom: 16 }}>
                <DefaultButton
                  text={t('VIEW DELIVERY ZONES MAP')}
                  onClick={() => this.setState({ showDeliveryZonesMap: true })}
                  fullWidth
                />
              </div>

              {showDeliveryZonesMap && (
                <DeliveryZonesMapModal
                  venueName={name}
                  lat={lat}
                  lng={lng}
                  zones={deliveryZones}
                  onZoneDrawn={(index, polygon) =>
                    this.setState({
                      deliveryZones: deliveryZones.map((zone, i) => (i === index ? { ...zone, polygon } : zone)),
                    })
                  }
                  onClearPolygon={(index) =>
                    this.setState({
                      deliveryZones: deliveryZones.map((zone, i) => (i === index ? { ...zone, polygon: [] } : zone)),
                    })
                  }
                  onToggleZone={(index, enabled) =>
                    this.setState({
                      deliveryZones: deliveryZones.map((zone, i) => (i === index ? { ...zone, enabled } : zone)),
                    })
                  }
                  onDeleteZone={(index) =>
                    this.setState({
                      deliveryZones:
                        deliveryZones.length > 1
                          ? deliveryZones.filter((_, i) => i !== index)
                          : [{ max_distance_miles: '', min_order: '', delivery_fee: '' }],
                    })
                  }
                  onClose={() => this.setState({ showDeliveryZonesMap: false })}
                />
              )}
            </Col>
            }
            <Col md={12}>
              <p className="add-venue-subtitle">{t('Photo')}</p>
              <Uploader onChange={this.onProductPhotoChange} />
            </Col>
          </Row>
          <p className="add-venue-subtitle">{t('Location')}</p>
          <Row>
            <Col md={4}>
              <CountrySelect
                label={t('Country')}
                error={invalidPost.country}
                errorText={t('Country is required')}
                defaultValue={country}
                onChange={(data) => {
                  this.setState({ country: data.value });
                }}
              />
            </Col>
            <Col md={12}>
              <Map
                containerClass="add-venue-map"
                coordinates={{
                  lng,
                  lat,
                }}
                defaultCoordinate={Constants.COUNTRIES[country].coordinates}
                search={true}
                marker={true}
                error={invalidPost.lng || invalidPost.lat}
                errorText={t('Please pin the venue address')}
                onRef={(ref) => (this.map = ref)}
                onClick={this.onMapClick}
              ></Map>
            </Col>
          </Row>

          <div className="modal-buttons-container">
            <div className="modal-button">{loading || <DefaultButton text={t('CANCEL')} onClick={() => this.show(false)} fullWidth></DefaultButton>}</div>
            <div className="modal-button">
              <LoadingButton text={venueId ? t('UPDATE') : t('SAVE VENUE')} state={loading ? 'LOADING' : 'DONE'} onClick={this.onSaveBtnCLick} fullWidth></LoadingButton>
            </div>
          </div>
        </ModalLayout>
      )
    );
  }
}

export default withTranslation()(SaveVenueModal);
